import React from 'react';
import { useAuth } from '../contexts/AuthContext';

/** A single fixed layer behind the app that renders the user's chosen
 *  wallpaper style. Defined in App.css under .wallpaper-layer[data-wallpaper]. */
export default function WallpaperLayer() {
  const { user } = useAuth();
  const wallpaper = user?.wallpaper || 'grain';
  return <div aria-hidden className="wallpaper-layer" data-wallpaper={wallpaper} />;
}
